import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import SimpleBar from "simplebar-react";
import FeatherIcon from "feather-icons-react";
import { getOnlineUsers } from "../../../api/requests/online-users-requests";

const GREEN = "#71C30B";
const ORANGE = "#E56A22";
const NAVY = "#221C5D";
const REFRESH_MS = 60000;
const ROW_HEIGHT = 52;
const VISIBLE_ROWS = 5;
const MAX_ROWS = 10;

const STYLES = `
  .online-dd .online-count {
    position: absolute; top: 12px; right: 2px; min-width: 18px; height: 18px;
    padding: 0 5px; border-radius: 999px; background: ${GREEN}; color: #fff;
    font-size: 11px; font-weight: 700; line-height: 18px; text-align: center;
  }
  .online-dd .online-row { display: flex; align-items: center; gap: .6rem; height: ${ROW_HEIGHT}px; padding: 0 1rem; border-bottom: 1px solid #f1f3f6; }
  .online-dd .online-dot { width: 8px; height: 8px; border-radius: 50%; background: ${GREEN}; flex-shrink: 0; }
`;

const minutesAgo = (value) => {
  if (!value) return "";
  const m = Math.floor((Date.now() - new Date(value).getTime()) / 60000);
  return m < 1 ? "Az önce" : `${m} dk önce`;
};

/** Süper admin üst barı: şu an çevrimiçi kullanıcı sayısı ve kısa liste. */
const OnlineUsersDropdown = () => {
  const [open, setOpen] = useState(false);
  const [users, setUsers] = useState([]);

  const load = useCallback(async () => {
    try {
      const res = await getOnlineUsers();
      setUsers(res.data || []);
    } catch {
      // Sayaç yalnız bilgi amaçlı; hata üst barı bozmasın.
    }
  }, []);

  useEffect(() => {
    load();
    const timer = setInterval(load, REFRESH_MS);
    return () => clearInterval(timer);
  }, [load]);

  const toggle = () => {
    if (!open) load();
    setOpen(!open);
  };

  const count = new Set(users.map((u) => u.userId)).size;
  const mobileCount = users.filter((u) => u.clientType === "MOBILE").length;
  const shown = users.slice(0, MAX_ROWS);
  const hiddenCount = users.length - shown.length;

  return (
    <React.Fragment>
      <style>{STYLES}</style>
      <Dropdown isOpen={open} toggle={toggle} className="dropdown d-inline-block online-dd" tag="li">
        <DropdownToggle className="btn header-item position-relative" tag="button" title="Çevrimiçi kullanıcılar">
          <FeatherIcon icon="users" className="icon-lg" />
          {count > 0 && <span className="online-count">{count > 99 ? "99+" : count}</span>}
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0 online-dd">
          <div className="p-3 border-bottom">
            <h6 className="m-0">Şu an çevrimiçi ({count})</h6>
            <div className="text-muted" style={{ fontSize: ".75rem" }}>
              Son 5 dakika · {users.length - mobileCount} tarayıcı, {mobileCount} mobil
            </div>
          </div>

          <SimpleBar style={{ maxHeight: `${ROW_HEIGHT * VISIBLE_ROWS}px` }}>
            {users.length === 0 ? (
              <div className="text-center text-muted p-4" style={{ fontSize: ".85rem" }}>
                Şu an çevrimiçi kullanıcı yok.
              </div>
            ) : (
              shown.map((u) => (
                <div key={`${u.userId}-${u.clientType}`} className="online-row">
                  <span className="online-dot" />
                  <div className="flex-grow-1" style={{ minWidth: 0 }}>
                    <div className="fw-semibold text-truncate" style={{ fontSize: ".85rem", color: NAVY }}>
                      {u.username || u.email}
                    </div>
                    <div className="text-muted text-truncate" style={{ fontSize: ".72rem" }}>
                      {u.accountName || u.companyName || "-"}
                    </div>
                  </div>
                  <div className="text-end flex-shrink-0">
                    <div style={{ fontSize: ".72rem", fontWeight: 600, color: u.clientType === "MOBILE" ? ORANGE : NAVY }}>
                      <i className={`bx ${u.clientType === "MOBILE" ? "bx-mobile" : "bx-desktop"} me-1`} />
                      {u.clientType === "MOBILE" ? "Mobil" : "Tarayıcı"}
                    </div>
                    <div className="text-muted" style={{ fontSize: ".7rem" }}>{minutesAgo(u.lastSeenAt)}</div>
                  </div>
                </div>
              ))
            )}
          </SimpleBar>

          <div className="p-2 border-top d-grid">
            <Link to="/admin/online-users" className="btn btn-sm btn-link font-size-14 text-center" onClick={() => setOpen(false)}>
              {hiddenCount > 0 ? `+${hiddenCount} kişi daha · Tümünü gör` : "Tümünü gör"}{" "}
              <i className="bx bx-right-arrow-alt" />
            </Link>
          </div>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default OnlineUsersDropdown;
